<template>
  <div class="container">
    <div class="login-information">▷ ▶ ▶▶</div>
  </div>
</template>
  
  <script>
  import Cookies from 'js-cookie';
export default {
  data() {
    return {
      userinfo: {},
      accessToken:'',
      rules: {},

      // 获取当前语言
      language: this.$i18n.locale,
      callback: "",
    };
  },

  mounted() {
    // 获取完整 URL
    const url = window.location.href;
    // 解析 URL 中的查询参数
    const params = new URLSearchParams(window.location.search);
    // 获取 tre_ep 参数值
    const treEpValue = params.get("tre_ep");
    
    // 获取 trer_source_type 参数值
    const trerSourceType = params.get("trer_source_type");
    
    // 获取 trer_source_id 参数值
    const trerSourceId = params.get("trer_source_id");
    

    const datas = {
      tre_ep: treEpValue,
      // tre_ep: "b9b0d35f9b636",
      trer_source_type:trerSourceType,
      trer_source_id:trerSourceId
    };
    console.log('datas的内容',datas);

    this.accessToken=Cookies.get('accessToken');
    if(!this.accessToken){
        this.$jumpLogin();
        return false;
    }

    this.insertScript(
      "/static/raffle/index.js?version=11",
      JSON.stringify(datas),
      function () {}
    );
  },
  methods: {
    insertScript(path, data, callback) {
      var new_element = document.createElement("script");
      new_element.setAttribute("type", "text/javascript");
      new_element.setAttribute("src", path);
      new_element.setAttribute("data-param", data);
      new_element.onload = callback; // 加载完成后调用回调

      document.body.appendChild(new_element);
    },
  },
};
</script>
  
<style lang="scss" scoped>
  /* 容器占满整个屏幕 */
.container {
  /* 固定定位使容器覆盖整个视口 */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  /* 使用Flexbox实现居中 */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  
  /* 可选：添加背景色使加载符号更明显 */
  /* background-color: rgba(255, 255, 255, 0.8); */
}

.login-information {
  /* 可以调整符号大小和样式 */
  font-size: 24px;
  color: #333;
  /* 添加动画使加载效果更明显 */
  animation: loading 1.5s infinite;
}

/* 加载动画 */
@keyframes loading {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>